'use client';
import { colors, font } from '@/theme/zeelool.theme';
import { FormControlLabel } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AddressFormData } from '.';
import Checkbox from '../Form/Checkbox';
import Switch from '../Form/Switch';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';

const FormItemSetDefault = ({
  formData,
  isNeedPagePadding = true,
}: {
  formData: UseFormReturn<AddressFormData>;
  isNeedPagePadding?: boolean;
}) => {
  const t = useTranslations('address');
  const [isChecked, setIsChecked] = useState(formData.getValues('default') === 1);
  return (
    <>
      <WebOnly>
        <div
          className={`${isNeedPagePadding ? 'ml-16 ' : ''} pl-8 flex items-center justify-between h-[40px]`}
        >
          <span className="text-primary-black text-16">
            <FormControlLabel
              label={t('setAsDefaultAddress')}
              sx={{
                '& .PrivateSwitchBase-input': {
                  height: '24px',
                  width: '24px',
                },
                '& .MuiButtonBase-root': {
                  padding: '0',
                },
                '& .MuiTypography-root': {
                  fontFamily: font.br,
                  marginLeft: '6px',
                  color: colors.primaryBlack,
                },
              }}
              control={
                <Checkbox
                  checked={isChecked}
                  inputProps={{ 'aria-label': 'controlled' }}
                  onChange={(event) => {
                    if (event.target.checked) {
                      formData.setValue('default', 1);
                      setIsChecked(true);
                    } else {
                      formData.setValue('default', 2);
                      setIsChecked(false);
                    }
                  }}
                  sx={{
                    padding: 0,
                  }}
                />
              }
            />
          </span>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="mx-16 flex items-center justify-between pb-64">
          <span className="text-primary-black text-14">{t('setAsDefaultAddress')}</span>
          <Switch
            checked={isChecked}
            inputProps={{ 'aria-label': 'controlled' }}
            onChange={(event) => {
              if (event.target.checked) {
                formData.setValue('default', 1);
                setIsChecked(true);
              } else {
                formData.setValue('default', 2);
                setIsChecked(false);
              }
            }}
            width={42}
            height={22}
          />
        </div>
      </WapOnly>
    </>
  );
};

export default FormItemSetDefault;
